import { connect } from 'react-redux';

import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MetricsSpace, MetricsStateProps } from './MetricsSpace';


const mapStateToProps: MapStateToProps<MetricsStateProps> = (state: AppState) => ({
  activeSubspaceName: state.spaceInfo.subspaceName,
  urls: siteUrlsSelector(state),
});

export const ConnectedMetricsSpace = connect(mapStateToProps)(MetricsSpace);
